/** @format */

import { ChangeDetectionStrategy, Component } from '@angular/core';
@Component({
	selector: 'plp-components-skeleton-specs-section',
	standalone: true,
	templateUrl: './skeleton-specs-section.component.html',
	styleUrl: './skeleton-specs-section.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SkeletonSpecsSectionComponent {

	trackbyFn(index: number): number {
		return index;
	}
}
